module.exports = __webpack_public_path__ + "static/media/route-interstate.9bc9f0d1.svg";